import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "upkar_token";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const CATEGORY = {
  equipment_service: "Equipment Service",
  mgps_installation: "MGPS Installation",
  mgps_inspection: "MGPS Inspection",
  sales_visit: "Sales Visit",
};
export const TASK_STATUS = {
  assigned: "Assigned",
  in_progress: "In Progress",
  pending_spares: "Pending Spares",
  completed: "Completed",
  cancelled: "Cancelled",
};
export const STAGE = {
  new: "New Inquiry",
  contacted: "Contacted",
  quotation_sent: "Quotation Sent",
  demo_scheduled: "Demo Scheduled",
  won: "Won",
  lost: "Lost",
};
export const DEPT = { sales: "Sales", service: "Equipment Service", mgps: "MGPS", hr: "HR", management: "Management" };
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const MGPS_CATS = ["mgps_installation", "mgps_inspection"];

export const mapsLink = (c) =>
  c?.lat != null
    ? `https://www.google.com/maps/dir/?api=1&destination=${c.lat},${c.lng}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${c?.hospital_name || ""} ${c?.address || ""}`)}`;

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export function getPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("GPS is not available on this device"));
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => reject(new Error("Location permission denied. Please enable GPS to continue.")),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 }
    );
  });
}

export async function uploadBlob(blob, name) {
  const fd = new FormData();
  fd.append("file", blob, name);
  const { data } = await api.post("/upload", fd);
  return data.path;
}

export async function dataUrlToBlob(dataUrl) {
  const r = await fetch(dataUrl);
  return r.blob();
}

export async function downloadFile(url, filename) {
  const { data } = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}
